const headRowsTypeService = {
  actions:'Acciones',
  name: 'Tipo de Servicio'
};

export default headRowsTypeService;
